import { id3, id6, id11, id22 } from "./fast";
// ============================================================================
// FULL / GLOBAL IDS (UUID replacement → 22 chars, 128 bits)
// ============================================================================
export const sessionId = () => id22();
export const agentId = () => id22();
export const cellId = () => id22();
export const profileId = () => id6();
export const mappingId = () => id6();
export const uploadId = () => id3();
export const connectionId = () => id22();
export const jobId = () => id11();
export const messageId = () => id11();
export const correlationId = () => id11();
export const onboardingId = () => id6();
// ============================================================================
// STRUCTURED / SCOPED IDS (short, safe)
// ============================================================================
// Orgs: global-ish, but still limited
export const orgId = () => id11();
// Projects: ≤ 3k per org
export const projectId = () => id6();
// Apps: ≤ 1k per project
export const appId = () => id6();
// Versions: ≤ 256 per app
export const versionId = () => id3();
// ============================================================================
// TOKEN / HEADER OPTIMIZED IDS
// ============================================================================
// JWT `jti`
export const jwtId = () => id11();
// JWT `kid` (key identifier for key rotation)
export const kidId = () => id3();
// HTTP optimistic concurrency
export const etag = () => id11();
// ============================================================================
// SHARE / SHORT IDS (user-facing, scoped)
// ============================================================================
export const shareId = () => id6();
export const shortId = () => id6();
// ============================================================================
// CASTING UTILITIES (for migration/compatibility)
// ============================================================================
/** Cast a string to SessionId */
export function asSessionId(id) {
    return id;
}
/** Cast a string to AgentId */
export function asAgentId(id) {
    return id;
}
/** Cast a string to JobId */
export function asJobId(id) {
    return id;
}
/** Cast a string to OrgId */
export function asOrgId(id) {
    return id;
}
/** Cast a string to ProjectId */
export function asProjectId(id) {
    return id;
}
/** Cast a string to CellId */
export function asCellId(id) {
    return id;
}
/** Cast a string to AppId */
export function asAppId(id) {
    return id;
}
/** Cast a string to VersionId */
export function asVersionId(id) {
    return id;
}
/** Cast a string to ProfileId */
export function asProfileId(id) {
    return id;
}
/** Cast a string to MappingId */
export function asMappingId(id) {
    return id;
}
/** Cast a string to UploadId */
export function asUploadId(id) {
    return id;
}
/** Cast a string to ConnectionId */
export function asConnectionId(id) {
    return id;
}
/** Cast a string to MessageId */
export function asMessageId(id) {
    return id;
}
/** Cast a string to CorrelationId */
export function asCorrelationId(id) {
    return id;
}
/** Cast a string to ShareId */
export function asShareId(id) {
    return id;
}
/** Cast a string to ShortId */
export function asShortId(id) {
    return id;
}
/** Cast a string to JwtId */
export function asJwtId(id) {
    return id;
}
/** Cast a string to KidId */
export function asKidId(id) {
    return id;
}
/** Cast a string to ETag */
export function asETag(id) {
    return id;
}
/** Cast a string to OnboardingId */
export function asOnboardingId(id) {
    return id;
}
